const baseUrl = "/audit-trail";

export const GET_AUDIT_LOGS = `${baseUrl}/`;

export const GET_USER_TRAIL = `${baseUrl}/get-user-trail`;

export const CREATE_AUDIT_TRAIL = `${baseUrl}/`;

export const GET_LIST = `${baseUrl}/get-list`;

export const GET_DOC_LOG_LIST = `${baseUrl}/get-doc-logs`;
